import api from "../../../services/apiClient";
import API_ENDPOINTS from "../../../config/apiEndpoints";
import utils from "../../../utils/utils";

function toRows(response) {
  if (!response || Number(response.success) !== 1) return [];
  const data = response.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.Table)) return data.Table;
  if (Array.isArray(data?.Tables?.[0])) return data.Tables[0];
  return [];
}

export async function fetchStudyMgmtList({
  organizationId,
  staffIdRef,
  createdBy,
  action,
}) {
  const response = await api.post(API_ENDPOINTS.STUDY.GET_STUDY_MGMT_LIST, {
    OrganizationId: organizationId,
    StaffIdRef: staffIdRef,
    CreatedBy: createdBy,
    Action: action,
  });
  if (!utils.isApiSuccess(response)) {
    throw new Error(
      utils.getApiResponseMessage(response, "Could not load study list."),
    );
  }
  return toRows(response);
}

export async function fetchStudyMgmtListBundle(userData) {
  const organizationId = userData?.OrganizationId;
  const staffIdRef = userData?.StaffId;
  const createdBy = userData?.StaffId;
  if (!organizationId || !createdBy) {
    return { liveRows: [], archivedRows: [] };
  }

  const listPayload = {
    organizationId,
    staffIdRef,
    createdBy,
  };

  const [liveRows, archivedRows] = await Promise.all([
    fetchStudyMgmtList({
      ...listPayload,
      action: "GetStudyMgmtLiveList",
    }),
    fetchStudyMgmtList({
      ...listPayload,
      action: "GetStudyMgmtArchivedList",
    }).catch(() => []),
  ]);

  return { liveRows, archivedRows };
}
